module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "boilerplate-item mb-3"
  }, [_c('h2', [_vm._v(_vm._s(_vm.item.title))]), _vm._v(" "), _c('h4', {
    staticClass: "h5 mb-2"
  }, [_c('i', {
    staticClass: "fa fa-star mr-2",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(_vm._s(_vm.item.star_count) + "\n      "), _c('i', {
    staticClass: "fa fa-eye mr-2 ml-4",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(_vm._s(_vm.item.watch_count) + "\n      "), _c('i', {
    staticClass: "fa fa-code-fork mr-2 ml-4",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.item.fork_count) + "\n  ")]), _vm._v(" "), _c('p', [_c('small', [_c('strong', [_vm._v("Last updated")]), _vm._v(" " + _vm._s(_vm._f("timeSince")(_vm.itemdata.updated_at)))])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.item.description))]), _vm._v(" "), _c('p', {
    staticClass: "boilerplate-links mb-0 mt-2"
  }, [_c('a', {
    staticClass: "btn btn-primary align-items-center mr-2",
    attrs: {
      "href": _vm.item.url,
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-github mr-2",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n          View Repository\n      ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary",
    attrs: {
      "href": _vm.item.zip_url,
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-file-archive-o mr-2",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n          Download\n      ")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-29248426","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/boilerplate-item.vue
// module id = 185
// module chunks = 1